import HeaderProps from "./_header-props.js";
import HeaderSearch from "./_header-search.js";
import HeaderBackground from "./_header-background.js";
import HeaderShared from "./_header-shared.js";
import HeaderButtonColors from "./_header-button-colors.js";

class HeaderMobile {
  /*
   * Toggles the hamburger icon on or off
   */
  toggleHamburger(open = true) {
    const $hamburger = HeaderProps.$header.querySelector(
      "[data-header-hamburger]",
    );

    if (open) {
      $hamburger?.classList.add("c-header__hamburger--active");
    } else {
      $hamburger?.classList.remove("c-header__hamburger--active");
    }
  }

  /*
   * Handles the mobile navigation
   */
  setup() {
    this.setupHamburger();
    this.setupDeepestListsToCloseSiblingsOnOpen();
    this.toggleHeaderState();
  }

  setupHamburger() {
    const $hamburger = HeaderProps.$header.querySelector(
      "[data-header-hamburger]",
    );
    $hamburger?.addEventListener("click", (_) => {
      const $rootNav = HeaderProps.$header.querySelector("#root-nav");
      const rootNavActive = $rootNav.classList.contains(
        "o-list-transition--in",
      );
      const searchModeOn = HeaderSearch.searchModeIsOn();

      if (rootNavActive && searchModeOn) {
        $rootNav?.setTransitionOut(false, true);
        HeaderSearch.manuallyTurnSearchModeOff();
      } else if (rootNavActive) {
        HeaderButtonColors.markAllListsAsNeutral();
        $rootNav?.setTransitionOut(false, true);
      } else if (searchModeOn) {
        HeaderSearch.manuallyTurnSearchModeOff();
      } else {
        $rootNav?.setTransitionIn(true, true);
      }
      HeaderBackground.handleHeaderCollapse();
    });
  }

  setupDeepestListsToCloseSiblingsOnOpen() {
    const $transitionLists = HeaderProps.$header.querySelectorAll(
      "[data-list-transition]",
    );
    const $deepestLists = [...$transitionLists].filter(($list) => {
      return $list.querySelectorAll("[data-list-transition]").length === 0;
    });

    $deepestLists.forEach(($list) => {
      $list.addEventListener("list-open", (_) => {
        if (!$list.closest("[data-header-search-results]")) {
          HeaderShared.closeSiblingLists($list);
        }
      });
    });
  }

  /*
   * Toggles the header state to mobile
   * if the window is resized to mobile, and the previous width was not mobile,
   */
  toggleHeaderState() {
    // get the hamburger toggle
    const $hamburger = HeaderProps.$header.querySelector(
      "[data-header-hamburger]",
    );
    console.assert($hamburger, "$hamburger button not found");

    // get the root navigation element
    const $rootNav = HeaderProps.$header.querySelector("#root-nav");

    // check if the hamburger is active
    const hamburgerActive = $hamburger.classList.contains(
      "c-header__hamburger--active",
    );

    // if the hamburger is not active, close the root navigation
    if (!hamburgerActive) {
      $rootNav?.setTransitionOut(true);
      HeaderButtonColors.markAllListsAsNeutral();
      return;
    }

    // check if the window size is mobile
    const isMobile = matchMedia(
      `(max-width: ${HeaderProps.breakPoint})`,
    ).matches;

    // if the window size is mobile, and the previous width was not mobile
    if (isMobile && !this._previousWidthWasMobile) {
      // get all the transition lists within the header
      const $transitionLists = HeaderProps.$header.querySelectorAll(
        "[data-list-transition]",
      );

      // close all the transition lists
      $transitionLists.forEach(($transitionList) => {
        $transitionList.triggerTransition("close");
      });
    }

    HeaderBackground.handleHeaderCollapse();
    this._previousWidthWasMobile = isMobile;
  }
}

export default new HeaderMobile();
